import React from "react";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import SubHeader from "../components/SubHeader";
import "./About.css";

export default function About() {
  return (
    <>
      <section className="about" id="about">
        <div className="container">
          <Fade left>
            <div className="about-img"></div>
          </Fade>
          <Fade right>
            <div className="about-context">
              <SubHeader
                title={"What We Do"}
                subheader={"We make therapy accessible."}
              />
              <p>
                At our core, we believe that everyone deserves access to the
                transformative power of therapy. We are committed to
                democratizing mental health care by making therapy not only
                acccessible but also affordable. Through our innovative virtual
                platform, we have revolutionized the way therapy is devlievered,
                making it convenient, flexible and available whenever and
                wherever you need it.
              </p>
              <Link to={"/therapists"} className="find-a-therapist">
                Find a therapist
              </Link>
            </div>
          </Fade>
        </div>
      </section>
      <hr style={{ color: "#000", position: "relative", zIndex: 12343 }} />
    </>
  );
}
